/* istanbul ignore file */
const styles = ({
  palette: {
    grey: { G200, G600 },
    secondary: { normal },
    text: { dark }
  },
  spacing: { unit },
  typography
}) => ({
  topSection: {
    borderBottom: `solid ${unit / 8}px ${normal}`,
    padding: '20px 0',
    margin: '20px auto',
    width: unit * 77,
    '& h2': {
      color: dark,
      fontSize: unit * 2
    }
  },
  alertTitle: {
    textTransform: 'uppercase',
    fontSize: 16,
    margin: [7, 0, 10, 0],
    fontWeight: 'bold'
  },
  alert: {
    marginBottom: 32,
    width: 400,
    margin: '0 auto'
  },
  label: {
    color: G600,
    fontSize: unit * 1.5,
    fontWeight: typography.fontWeightHeavy,
    padding: `0px 0px ${unit * 1.5}px`,
    textTransform: 'uppercase'
  },
  section: {
    padding: `${unit * 3}px 0 ${unit * 0.5}px`,
    borderBottom: `1px solid ${G200}`,
    display: 'flex'
  },
  title: {
    padding: [0, unit * 2, unit * 1.5],
    color: dark,
    fontSize: unit * 2.5,
    fontWeight: typography.fontWeightHeavy,
    textAlign: 'center'
  },
  sectionTitle: {
    padding: [0, unit * 2, unit * 2],
    color: dark,
    fontSize: typography.fontSize,
    fontWeight: typography.fontWeightHeavy
  },
  details: {
    display: 'flex',
    flexWrap: 'wrap',
    '& div': {
      color: dark,
      fontSize: unit * 1.5
    }
  },
  tableContainer: {
    margin: unit * 8,
    width: unit * 112.5
  },
  tableWrapper: {
    minHeight: 450,
    '& .table': {
      border: '0'
    },
    '& .table > thead': {
      backgroundColor: '#fff'
    },
    '& .table > tbody > tr': {
      backgroundColor: '#fff',
      borderBottom: `solid ${unit / 4}px ${normal}`
    },
    '& .table > thead > tr > th': {
      border: '0',
      borderBottom: `solid ${unit / 2.5}px ${normal}`,
      color: dark,
      fontWeight: typography.fontWeightRegular,
      padding: '0px',
      textTransform: 'uppercase',
      verticalAlign: 'middle',
      width: unit * 12,
      '&.noBorder': {
        border: 'none',
        paddingTop: 0,
        paddingBottom: 0,
        fontWeight: typography.fontWeightHeavy,
        textTransform: 'uppercase'
      }
    },
    '& .table > thead > tr.messageRow': {
      backgroundColor: G200,
      '& th': {
        borderBottom: `1px solid ${G600}`,
        padding: `${unit * 1.25}px`,
        textAlign: 'right',
        textTransform: 'capitalize'
      }
    },
    '& .table > thead > tr > th:first-child': {
      width: unit * 25
    },
    '& .table > thead > tr > th:nth-child(4)': {
      width: unit * 25
    },
    '& .table > tbody > tr > td': {
      border: '0',
      padding: `${unit * 2}px 0px`,
      width: unit * 12
    },
    '& .table > tbody > tr > td:first-child': {
      width: unit * 25
    },
    '& .table > tbody > tr > td:nth-child(4)': {
      width: unit * 25
    }
  },
  buttons: {
    textAlign: 'center',
    paddingBottom: unit * 4
  }
});

export default styles;
